import React from 'react';
import { Card, CardContent, Stack, Avatar, Box, Typography, Chip, Tooltip, Button } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { Link as RouterLink } from 'react-router-dom';

export interface MemberCardProps {
  member: any;
  showActions?: boolean; // show "Profile" and "More in {state}" buttons
}

const MemberCard: React.FC<MemberCardProps> = ({ member, showActions = true }) => {
  const bio = member?.bioguide_id || member?.bioguideId || member?.id;
  const name = member?.name || (member?.firstName && member?.lastName ? `${member.firstName} ${member.lastName}` : (member?.first_name && member?.last_name ? `${member.first_name} ${member.last_name}` : '—'));
  const state = member?.state;
  const party = member?.party;
  const sponsored = typeof member?.sponsored_count === 'number' ? member.sponsored_count : (typeof member?.sponsoredCount === 'number' ? member.sponsoredCount : undefined);
  const score = typeof member?.trending_score === 'number' ? member.trending_score : (typeof member?.trendingScore === 'number' ? member.trendingScore : null);
  const imageUrl = member?.image_url || member?.imageUrl || undefined;

  return (
    <Card
      variant="outlined"
      sx={{ borderRadius: 3, height: '100%', transition: 'transform 0.2s ease, box-shadow 0.2s ease', '&:hover': { transform: 'translateY(-2px)', boxShadow: 6 } }}
    >
      <CardContent>
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar src={imageUrl} alt={name} sx={{ width: 48, height: 48 }} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" noWrap title={name}>{name}</Typography>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5, flexWrap: 'wrap' }}>
              {party && <Chip label={party} size="small" />}
              {state && <Chip label={state} size="small" variant="outlined" />}
              {score !== null && (
                <Tooltip title={`Trending score: ${score}`}>
                  <Chip icon={<TrendingUpIcon />} label={String(score)} size="small" color={score >= 67 ? 'success' : score >= 34 ? 'warning' : 'default'} />
                </Tooltip>
              )}
            </Stack>
            {typeof sponsored === 'number' && (
              <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
                Sponsored bills: {sponsored}
              </Typography>
            )}
          </Box>
        </Stack>
        {showActions && (
          <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
            {bio && (
              <Button size="small" component={RouterLink as any} to={`/members/${bio}`} variant="contained">Profile</Button>
            )}
            <Button size="small" component={RouterLink as any} to={`/members?state=${encodeURIComponent(state || '')}`} variant="text">More in {state || 'state'}</Button>
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};

export default MemberCard;
